import type { Citation } from "@/lib/citations";

/**
 * The primary sources behind the free excavation selector
 * (/free/excavation-support-selector). Every point the selector shows names
 * one of these, read on the accessed date: CDM 2015 regulation 22 on
 * legislation.gov.uk (the legal anchor) and HSE's "Excavations" page, which
 * every HSE quotation in lib/marketing/excavation-selector/selector.ts comes
 * from word for word.
 */
const ACCESSED = "2026-10-31";

export const CDM_REG_22_URL = "https://www.legislation.gov.uk/uksi/2015/51/regulation/22";
export const HSE_EXCAVATIONS_URL = "https://www.hse.gov.uk/construction/safetytopics/excavations.htm";
export const HSENI_CDM_URL =
  "https://www.hseni.gov.uk/articles/construction-design-and-management-regulations-northern-ireland-2016";
export const CDM_NI_URL = "https://www.legislation.gov.uk/nisr/2016/146/contents";

export const EXCAVATION_SELECTOR_SOURCES: readonly Citation[] = [
  {
    title: "The Construction (Design and Management) Regulations 2015, regulation 22 (Excavations)",
    url: CDM_REG_22_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
  {
    title: "Excavations",
    url: HSE_EXCAVATIONS_URL,
    publisher: "Health and Safety Executive",
    accessedAt: ACCESSED,
  },
  {
    title: "The Construction (Design and Management) Regulations (Northern Ireland) 2016",
    url: CDM_NI_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
];
